






















import { Component, Vue } from "vue-property-decorator";
import list from "./list.vue";
import userInfo from "./userInfo.vue";

@Component({
  components: {
    list,
    userInfo,
  },
})
export default class HomeTab extends Vue {
  private item: any = {
    indexId: 1,
    icon: "https://www.baidu.com/img/baidu.svg",
    title: "test",
  };

  private test: any = {
    indexId: 1,
    icon: "",
    title: "test",
  };
}
